/**
 * This is a factory of function to use in React.useEffect
 *
 * Example:
 * ```js
 * React.useEffect(() => createUseHotkey(...), [...]);
 * ```
 */
export const createUseHotkey = ({
  codes,
  onHotkey,
}: {
  /**
   * `event.code` to watch for
   */
  codes: string[];
  onHotkey: (params: { code: string }) => void;
}) => {
  const keyPress = (event: KeyboardEvent) => {
    if (
      !codes.includes(event.code) ||
      // ignore if someone is typing currently
      ['INPUT', 'TEXTAREA'].includes(event.target?.['tagName'])
    ) {
      return;
    }

    event.preventDefault();

    onHotkey({ code: event.code });
  };

  document.addEventListener('keydown', keyPress);

  return () => document.removeEventListener('keydown', keyPress);
};
